import { checkStatus } from './normalizer';

const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

export async function fetchUWLocationResearchResults(
    locationName: string,
    locationAddress?: string,
    researchTerm?: string,
    researchSite?: string,
    num: number = 10,
    start: number = 1
) {
    let url = `https://www.googleapis.com/customsearch/v1?cx=9b06994b880437d80&key=${GOOGLE_API_KEY}&num=${num}&start=${start}&q=${
        locationName || ''
    } ${locationAddress || ''} ${researchTerm || ''}`;
    if (researchSite) {
        url += `&siteSearch=${researchSite}&siteSearchFilter=i`;
    }

    const options = {
        method: 'GET',
        headers: new Headers({
            Accept: 'application/json',
        }),
    };
    return fetch(url, options)
        .then(checkStatus)
        .then((resp: Response): any => resp.json())
        .then((data: any) => data.items || []);
}
